export interface DropDownModal {
  name: string;
  value: string;
}
